export default "__VITE_ASSET__DMjJdm_k__"